import { BrandSplitType } from '../../../brand-split-settings/brandSplitSettings.types';
import { OrderType } from '../../interfaces/orderType.enum';
import {
  UseOrderBillingForecastParams,
  UseOrderBillingForecastReturn,
} from '../interfaces/orderCondition.interface';
import { checkRule, isRuleBasedOnDeliveryWindow } from '../utils/orderConditions.utils';

const useOrderBillingForecast = ({
  orderCondition,
  ruleForPreOrder,
  orderSplitSettings,
  ruleForReadyForDelivery,
}: UseOrderBillingForecastParams): UseOrderBillingForecastReturn => {
  const orderType = orderCondition?.orderType;
  const preOrderCheck = checkRule(ruleForPreOrder);
  const readyForDeliveryCheck = checkRule(ruleForReadyForDelivery);

  const isOrderSplitByDeliveryWindow =
    orderSplitSettings &&
    orderSplitSettings.some((setting) => setting.type === BrandSplitType.DELIVERY_WINDOW);

  if (
    !isOrderSplitByDeliveryWindow &&
    orderType === OrderType.PRE_ORDER &&
    isRuleBasedOnDeliveryWindow(ruleForPreOrder)
  ) {
    return {
      showOrderBillingForecastDate: true,
      isReadOnlyOrderBillingForecastDate: false,
    };
  }

  const hasApplicableRule =
    (orderType === OrderType.PRE_ORDER && preOrderCheck.hasRule) ||
    (orderType === OrderType.READY_FOR_DELIVERY && readyForDeliveryCheck.hasRule);

  const shouldBeReadOnly =
    (orderType === OrderType.PRE_ORDER && preOrderCheck.hasRule && !preOrderCheck.isManual) ||
    (orderType === OrderType.READY_FOR_DELIVERY &&
      readyForDeliveryCheck.hasRule &&
      !readyForDeliveryCheck.isManual);

  return {
    showOrderBillingForecastDate: hasApplicableRule,
    isReadOnlyOrderBillingForecastDate: orderType !== OrderType.BOTH && shouldBeReadOnly,
  };
};

export default useOrderBillingForecast;
